import {IBaseItemListData} from "./structural";
import {Routable} from "./kiosk";

export interface SearchResult extends IBaseItemListData, Routable {

}
